import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getMisc, updateSMSGroup } from "../../../apiclients/streamsapi_bridge";
import AddToUsers from "../../../views/popups/misc/AddToUsers";
import RemoveToUser from "../../../views/popups/misc/RemoveToUser";
import PopupLoader from "../../../views/popups/PopupLoader";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import TopMessage from "../../header/TopMessage";
import TopSuccess from "../../header/TopSuccess";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../CustomSearchUtil/CustomSearch";
import UIConstant from "../../../apiclients/UIConstant";

function SMSGroupUsers(props) {
  const { t, i18n } = useTranslation();
  const [addUser, setAddUser] = useState(false);
  const toggleOpen = () => setAddUser(!addUser);
  const [userList, setuserList] = useState([]);
  const [sourceUsers, setSourceUsers] = useState([]);
  const [updateUsers, setUpdateUsers] = useState([]);
  const [isAddedUsers, setIsAddedUsers] = useState(false);
  const [isdelete, setIsDelete] = useState(false);
  const dUtogglePopup = () => setIsDelete(!isdelete);
  const [isdeleteUser, setIsDeleteUser] = useState(false);
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState("");
  const [internalError, setInternalError] = useState(false);

  const addUserRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [smsGroupUserDetails, setSmsGroupUserDetails] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
  const searchRef = useRef(null);
  useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef, props.isActive);

  function handleClick() {
    addUserRef.current.click();
  }

  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  useEffect(() => {
    if (props.smsUsers && props.smsUsers.length > 0) {
      setuserList(props.smsUsers);
    }
  }, [props.smsUsers]);

  useEffect(() => {
    const processdrows = userList.map((user) => ({
      usersInfo: user,
      name: user?.name?.toString(),
      email: user.email ? user.email + "" : "",
      agentid: user.agentid ? user.agentid + "" : "",
      extension: user.extension ? user.extension : "--",
      delete: (
        <>
          <div className="d-flex align-items-center ms-2">
            <div
              className="custom-hover-bg p-1 cursor-pointer deleteToolTip"
              onClick={(e) => handleDelete(e, user)}
            >
              <MDBIcon
                fas
                icon="times"
                color="primary"
                className="mx-2 fs-5"
              />
            </div>
          </div>
        </>
      ),
    }));
    setSmsGroupUserDetails(processdrows);
    setFilteredRows(processdrows);
    setSearchValue("");
    setDataLoaded(true);
  }, [userList, props.isActive]);

  useEffect(() => {
    async function fetchData() {
      let UserList = [],
        apiResponse = {};
      apiResponse = await getMisc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        { misc: ["sms_users"], code: props.code }
      );

      if (apiResponse.status === 200) {
        const Users = await apiResponse.json();
        console.log(`SMS Group UserList ::::: ${JSON.stringify(Users)}`);

        UserList = Users.misc.users ?? [];
        console.log(`SMS Group UserList 11111::::: ${JSON.stringify(UserList)}`);
        // alert(JSON.stringify(UserList));
        setSourceUsers(UserList);
      } else {
      }
    }

    if (props.code && props.code != "") {
      fetchData();
    }
  }, [props.code]);

  const handleManualSearch = (value) => {
    setSearchValue(value);
    const filtered = customSearch(smsGroupUserDetails, value, UIConstant.SMS_GROUP_USERS);
    setFilteredRows(filtered);
  };

  const fixedData = {
    columns: [
      { label: "User Name", field: "name", sort: true },
      { label: "Email", field: "email" },
      { label: "Extension", field: "extension" },
      { label: "Remove", field: "delete", sort: false },
    ],
    rows: filteredRows,
  };

  const handleDelete = (event, infoObj) => {
    event.preventDefault();
    dUtogglePopup();
    setUpdateUsers([infoObj]);
  };

  useEffect(() => {
    if (updateUsers.length > 0 && isAddedUsers) {
      updateTheUser("addedUsers");
      setIsAddedUsers(false);
    }
  }, [updateUsers, isAddedUsers]);

  useEffect(() => {
    if (updateUsers.length > 0 && isdeleteUser) {
      updateTheUser("removedUsers");
      setIsDeleteUser(false);
    }
  }, [updateUsers, isdeleteUser]);

  async function updateTheUser(fieldName) {
    setInternalError(false);
    const agentids = new Set(updateUsers.map((item) => item.agentid));
    let update = {};

    let saverep;

    update = {
      reqid: 100,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      code: props.code,
      [fieldName]: Array.from(agentids),
    };
    console.log("SMS Add Remove Users Request ::: " + JSON.stringify(update));
    saverep = await updateSMSGroup(update);

    console.log(saverep);
    let saverepeMsg = await saverep.json();
    const usernames = new Set(updateUsers.map((item) => item.name));
    const users = Array.from(usernames).join(", ");
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      if (fieldName === "addedUsers") {
        const updatedUsers = [...userList, ...updateUsers];
        setuserList(updatedUsers);
        setSuccessMessage(`SMS Group User(s) ${users} added successfully.`);
      } else {
        const filterExtension = new Set(
          updateUsers.map((item) => item.extension)
        );
        const filterUsers = userList.filter(
          (item) => !filterExtension.has(item.extension)
        );
        setuserList(filterUsers);

        setSuccessMessage(`SMS Group User(s) ${users} removed successfully.`);
      }
    } else {
      if (fieldName === "removedUsers") {
        const filterExtension = new Set(
          updateUsers.map((item) => item.extension)
        );
        let modifyUser = userList.filter(
          (item) => !filterExtension.has(item.extension)
        );
        modifyUser = [...modifyUser, ...updateUsers];
        setuserList(modifyUser);

        setInternalError(true);
      }
    }
  }
  return (
    <>



      <div className="mb-3 general-settings m-0 ps-0">
        {t("users")}
      </div>
      <div className="smsgroupsdetails-datatable">
        <div className="actionbar">
          <MDBBtn className="ms-2" const toggleOpen onClick={toggleOpen}>
            <MDBIcon fas icon="plus" className="me-2" />
            {t("adduser")}
          </MDBBtn>
        </div>

        <div className='mb-2 mt-0 position-relative w-auto'>
          <MDBInput
            label="Search"
            ref={searchRef}
            value={searchValue}
            onChange={(e) => handleManualSearch(e.target.value)}
          />
          <MDBIcon fas icon="search" className='MDBDatatable-Search' />
        </div>
        <MDBDatatable
          key={searchValue}
          data={fixedData}
          sortField="User Name"
          // search
          fixedHeader
          entries={50}
          className="actioncolumn"
        />
      </div>

      {addUser && (
        <PopupLoaderNew
          title="Add Users"
          content={
            <AddToUsers
              onClose={toggleOpen}
              selectedUsers={userList}
              setUpdateUsers={setUpdateUsers}
              setIsAddedUsers={setIsAddedUsers}
              sourceUsers={sourceUsers}
              ref={addUserRef}
              setIsloading={setisLoading}
            />
          }
          onShow={setAddUser}
          onClose={toggleOpen}
          onSave={handleClick}
          isloading={isLoading}
          flag={1}
        />
      )}
      {isdelete && (
        <PopupLoaderNew
          title={"Remove User"}
          content={
            <RemoveToUser
              setIsDeleteUser={setIsDeleteUser}
              onClose={dUtogglePopup}
              ref={addUserRef}
              setIsloading={setisLoading}
              smsGroupUser = {true}
            />
          }
          onShow={setIsDelete}
          onClose={dUtogglePopup}
          onSave={handleClick}
          isloading={isLoading}
          flag={4}
        />
      )}
      {successMessage && (
        <>
          <TopSuccess>
            <TopMessage successMessage={successMessage} />
          </TopSuccess>
        </>
      )}

      {internalError && (
        <MDBAlert
          open
          className="alert-center"
          color="danger"
          autohide
          position="bottom-right"
          delay={5000}
          onClose={() => setInternalError(false)}
        >
          Internal Server Error
        </MDBAlert>
      )}
    </>
  );
}

export default SMSGroupUsers;
